export function formatFileSize(bytes, decimalPoint) {
  if (bytes === 0) return 0;
  const k = 1000;
  const dm = decimalPoint || 2;
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / k ** i).toFixed(dm));
}
